import type { ReactNode } from "react";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";

export const RunStatePanel = ({
  icon,
  machine,
  title,
  body,
  action,
  isAlert = false,
  isStatus = false,
}: {
  icon?: ReactNode;
  machine?: ReactNode;
  title: string;
  body: string;
  action?: ReactNode;
  isAlert?: boolean;
  isStatus?: boolean;
}) => (
  <Empty
    data-machine-host
    className={emptyStateVariants({ layout: "workspace" })}
    role={isAlert ? "alert" : isStatus ? "status" : undefined}
  >
    <EmptyHeader>
      {machine ? (
        <EmptyMedia>{machine}</EmptyMedia>
      ) : (
        <EmptyMedia variant="icon">{icon}</EmptyMedia>
      )}
      <EmptyTitle>{title}</EmptyTitle>
      <EmptyDescription>{body}</EmptyDescription>
    </EmptyHeader>
    {action && <EmptyContent data-machine-trigger>{action}</EmptyContent>}
  </Empty>
);
